// extracted by mini-css-extract-plugin
export default {"page-content":"profile_page-content__Yx3hZ"};